export default function Nail() {
  return (
    <>
      <rect
        x="0.3396"
        y="1.3241"
        width="32.5798"
        height="35.5215"
        transform="rotate(-1.36034 0.3396 1.3241)"
        fill="url(#pattern0_139_642)"
      />
      <g opacity="0.63">
        <rect
          x="1.89038"
          y="4.95044"
          width="36.2405"
          height="34.0567"
          transform="rotate(-1.36034 1.89038 4.95044)"
          fill="url(#pattern1_139_642)"
        />
      </g>
      <rect
        x="1.80347"
        y="1.28931"
        width="35.8744"
        height="35.5215"
        transform="rotate(-1.36034 1.80347 1.28931)"
        fill="url(#pattern2_139_642)"
      />
      <defs>
        <pattern
          id="pattern0_139_642"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_139_642"
            transform="scale(0.0111111 0.0103093)"
          />
        </pattern>
        <pattern
          id="pattern1_139_642"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image1_139_642" transform="scale(0.01 0.0107527)" />
        </pattern>
        <pattern
          id="pattern2_139_642"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image2_139_642"
            transform="scale(0.010101 0.0103093)"
          />
        </pattern>
        <image
          id="image0_139_642"
          width="90"
          height="97"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABhCAYAAABWFbZsAAAACXBIWXMAAAsSAAALEgHS3X78AAADQElEQVR4Xu3cwW4bRxBF0fuq+buxE8CSjTBeWdTCXCRSfne6XhZDbQQEzCKp9Bh1loIkCBeFYvcQomzT/ntx7xvav6NDF+nQRTp0kQ5dpEMX6dBFOnSRDl2kQxfp0EU6dJEOXaRDF+nQRTp0kQ5dpEMX6dBFOnSRDl2kQxfp0EU6dJEOXaRDF+nQRTp0kQ5dpEMX6dBFOnSRDl2kQxfp0EVO975hZefr73YOYKIY4MQhnj991L2frXao0Ofvr8YGRAKhwEoiA9++zrzzS/4nh1kdv11fTE4ssJPAJCKAHIBAChTLDTNwgIn+9fpiAAliDKaNGYjkJJEpZEMYLC6PH5YsvXTo8/XVInAmZt8KNgQThdmAgdEQ3gKNdf9ncvHVYZhG8m0rmwiIEDNjXxvATKNInh7WexF8s+xEf73+6bAAkzZywMk4AwQRCQhZDAEs2xhYOHTahM0cyQA2w0ghkpzCIRA4jD14/vzT0qWXDa0UGaAcbDbCZIjQwGECgTak4NuntSPDojv6/P3VjP0IB+J0AoUImekktIfHgzzIhwYsGdo2trDBI9kmoMQKxtvexiiTy8PPy08zLBj66/XFCqH0ftubEBjNgJmkEqWQwD5EY2DB0JtBM/cb4EmIQBIOsIwVTJKZ8PRl3ePce8uFVu63QEcwNmHlbR8HKBBG43Tb38ex3KlDEpsgyP3UIZEGa0MGLKyN58+/HGaaYcWJVjISwDhB8/ZULmOPvB/sDme5iTbGMsODjNxvgbdndZYIwdPDsaYZFgyNBpZITyCQTZLESfuZ+SDn5veWCy2DfDt1hMhMICAhEE+LPga9Z7nQZn9SJwnS+yqx94f9sdxLyj+23F9+efwofOJ2yUYR+/soCr49Hufc/N5yEw0Qpw0y9tn2flE52rn5veUmGiC3QYaYNppm2Fwej/FM4+8sGfry5YOUe2Dhg8/yTit/Nun5+of3N1yPu5vfLB36R7Lk6vgRdegiHbpIhy7SoYt06CIdukiHLtKhi3ToIh26SIcu0qGLdOgiHbpIhy7SoYt06CIdukiHLtKhi3ToIh26SIcu0qGLdOgiHbpIhy7SoYt06CIdukiHLtKhi3ToIh26yF+me0BeOIADzQAAAABJRU5ErkJggg=="
        />
        <image
          id="image1_139_642"
          width="100"
          height="93"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABdCAYAAABTl8MxAAAACXBIWXMAAAsSAAALEgHS3X78AAADlklEQVR4Xu3cS3IbRxBF0fuyegdUS6TsZTlMmnR4e/4uzKJor6ArnwcFhB2acCJLCTLvBJPGBKerstARgGzT1Smeu6D7sjVIsRqkWA1SrAYpVoMUq0GK1SDFapBiNUixGqRYDVKsBilWgxSrQYrVIMVqkGI1SLEapFgNUqwGKVaDFKtBitUgxWqQYjVIsRqkWA1SrAYpVoMUq0GK1SDFapBiNUixGqRYrxLkar/1m/27kj+u3J674CW17997phlhrHzu8q/SqwB5s9/aYWRQwNQA67m3fZVeNMjVfmthEJBAmEhASVJzhbzYGfJmv7UEDEDLBAEhbBC9Qr5IV/udR7BuNSUxwYgcximUxjKjt6z/t/3mBxszIskUbKC5kUzkYKTXNmUYDjJqblkXD3J1/WByAhAD0huMCQdIEwfYB2kIDRSQmajobn2xIG9v7oxhi7FOTTnxATkmI4EB6QGepDY2EgMHyYZ6qH/O3r67Nw5MrA9WhggkIwJLeAJOlBBzzQ3lgQRJ9lD/HO03DzaJbBTr7gcTczAxoWVDJBFi2hihBFs4BjZ4wN+Pv5cUuQiQ/f2PDk5POiSE8BQKoUPMzTBNCmQz1+AgptZGpUQ5yGHCCUVXB4Aq/1/W1Tf31twITYwAgxMksDEg1uvZywkEREx8BISBBAWeRoinj7+VFSk7Q/bre+PB4DiNXyMSaaBMAi0XiZHr85WMQgvlCBSAIRw41/spetw9V26F7O9/spRIMOd69hQzOTAb43Q6SuRYg1rrnjqOyRYmAa+v4oyESYIgJDTN49MfZVcHFFwhssHCcw1vEo4AaQGctx8kzg+p7EmEOBBoIK/t7WB9CVQO0qM8BhQEQeBMUpCIlDkP9HkyUApHstaDgCBkBsJMGMnwQAxSCUr+evylPAYU3LLO7d8+2AeMgHQiD0yiMJ4DRZIJ8oQAs+YEp+1uPSUJZPP08deLwIDCILCOu1jIp5kSRtPAYB1o/z0KO9dqOVkQTJy6KAwoDnJuv753aCyCXBAjBE4mwWCSDiBP21vw+OEytqhPuwiQ//bu5s5zDkaYg8k4jcHHP3++SIBPuziQl169U9Yrr0GK1SDFapBiNUixGqRYDVKsBilWgxSrQYrVIMVqkGI1SLEapFgNUqwGKVaDFKtBitUgxWqQYjVIsRqkWA1SrAYpVoMUq0GK1SDFapBiNUixGqRYDVKsBilWgxSrQYrVIMX6B3cHllSH9O40AAAAAElFTkSuQmCC"
        />
        <image
          id="image2_139_642"
          width="99"
          height="97"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABhCAYAAADC8x+eAAAACXBIWXMAAAsSAAALEgHS3X78AAADr0lEQVR4Xu3by24bRxCF4f9U82VjMluLDnRxLoAlbW05L8uuk0WPkkUSSKukRqpvpQUFEfynu3qGkGzTaoiXXtD+Ox2jkI5RSMcopGMU0jEK6RiFdIxCOkYhHaOQjlFIxyikYxTSMQrpGIV0jEI6RiEdo5COUUjHKKRjFNIxCukYhXSMQjpGIR2jkI5RSMcopGMU0jEK6RiFdIxCOkYhHaOQjlHI4aUXVHc8XxsHEebrl1/10usr230MEGHIFMfzjQEizdfH33YXRnv+b9fj1a0JIRsDaRMEaCICbL497Ge17HpmrOvITCXYaASOxBwQIMTpfOcfrj7v4orbbYwfP96uD3gGYhAWItEchCYTmCMxk1CuVVTcbmM4Eg3jQ2JMHhISFJPpbWdKgQ5gcJjTNlOq2uUAP13dWiPICYrAnpAAghADI4ERykkSa8gXv/SKv72/+7BtT3OyPnCbEQMQDoNNyqx9KtbiwAjD1DoKF7W7GI7AYUKAAYGmyVhHXGyUYooVJYVtZhqN9QvHc835sasYp0/XDiZCOLc3P01KIJMIYhCACFabxEMoBnKuo2/R/armu/o3EgphgSUuESgEuhApICHNBEgTJOOwbWcYZ3CRYeQLf+j/sZsBfvzpxnjgNMgoJpFByjgHCNae5fVjrBvAzMReEVMXBsGs2WI/MTRFOtHBhAeeQmFscxBYJm0soUwskQYQimQlCr59+aXsHfkuHoeczneeNoQZQFoogPTamSRC6448Yg1sWchJCjLE74UjPNvFypDMAbgg5gxCE23XUA6tEWAIQXqtipDJOXh6+Fw+wrPyA/zD+cZTgEykiAAp1hA34PhzoINBsU5QmKfH/YSAHayM9fRVXCYcDsnleQvahrB8IWP8tU2RPN3v7/E5FI9x+nTn9HaDJ61nTWwrYFsVEWab1Lt6XP5PSsdYVzqE1qOO5ztqbR+5lSTi6aH+cH6Nsqep48cbM9YWZU+GRCbkMGNCRvD9/uc3EeFZ4QE+WEemSYSZIeIAYwYZfnMhoOjKOJ6vjUTket6aFtZEDr4/vr0Iz0rODHms77Rjrvtmi2/3+x7Or1FuZRzPt3aYgcjJmxnOr1FyZbCdVt9TCCi4Mt6zwqep96djFNIxCukYhXSMQjpGIR2jkI5RSMcopGMU0jEK6RiFdIxCOkYhHaOQjlFIxyikYxTSMQrpGIV0jEI6RiEdo5COUUjHKKRjFNIxCukYhXSMQjpGIR2jkI5RSMcopGMU0jEK+QPlnJVK41uhtwAAAABJRU5ErkJggg=="
        />
      </defs>
    </>
  );
}
